import React from 'react';
import { Icon } from './Icon.js';
export const IconPencil = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M4.50002 14L7.16991 16.6699L10 19.5", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M13.2345 5.53912L18.4783 10.7829", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M9 20.2337L22 7.23371L16.7662 2.00001L3.76617 15L3.00321 21L9 20.2337Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconPencil.js.map